import { useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from '@examples/Navbars/DashboardNavbar';
import { useMaterialUIController } from 'context';
import { useTranslation } from 'react-i18next';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';
import { Integration, IntegrationService } from '../services/integration.service';
import { IntegrationFields } from '../components/integration-fields';
import { INTEGRATIONS_ROUTE, IntegrationBackButton } from '../components/integration-back-button';

const CHATWOOT_KEY = 'chatwoot';

/// Conexão com o Chatwoot: conta, caixas de entrada e liga/desliga, em passos quando o catálogo os declara.
export const ChatwootIntegration = () => {
    const { t } = useTranslation();
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);
    const navigate = useNavigate();

    const [integration, setIntegration] = useState<Integration | null>(null);

    const load = () =>
        new IntegrationService()
            .list()
            .then((res) => setIntegration((res.data.data ?? []).find((item) => item.key === CHATWOOT_KEY) ?? null))
            .catch(() => setIntegration(null));

    useEffect(() => {
        load();
    }, []);

    const goBack = () => {
        if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
        else navigate(INTEGRATIONS_ROUTE);
    };

    const hasSteps = (integration?.steps ?? []).length > 0;

    return (
        <DashboardLayout>
            <DashboardNavbar title={integration?.name ?? t('sideNav.configuracoes.integracoes')} />

            <Box sx={{ background: cc.pageBg, borderRadius: 3, p: 2 }}>
                <IntegrationBackButton />

                {!integration ? (
                    <Box>
                        <Skeleton variant="rounded" height={40} sx={{ mb: 2 }} />
                        <Skeleton variant="rounded" height={280} />
                    </Box>
                ) : (
                    <Box>
                        {!hasSteps && (
                            <Typography
                                variant="caption"
                                sx={{ color: cc.textSecondary, display: 'block', mb: 2 }}
                            >
                                {integration.description}
                            </Typography>
                        )}

                        <IntegrationFields integration={integration} onSaved={load} onClose={goBack} />
                    </Box>
                )}
            </Box>
        </DashboardLayout>
    );
};
